<template>
    <div name="recent" style="width: 100%; height: 100vh; overflow-y: auto;">
        <div class="tabs">
            <span class="inactive-tab-text" @click="tabChange">최근 검색어</span>
            <span class="active-tab-text" style="margin-left: 16px;">상품유형 검색</span>
        </div>
        <div class="line"></div>
        <div v-if="categoryList" class="category-list">
            <span class="category-title">상품유형<span class="category-count-title"> {{ categoryList.length }}</span></span>
            <div class="box" style="margin-top: 22px;">
                <div :key="`organization_${index}`" class="category-element" style="border-radius: 0;" v-for="(organization, index) in categoryList" @click="searchCategory(organization, 0, index)" >
                    <span class="category-element-text">{{ organization }}</span>
                    <img style="width: 22p;" src="../../../../assets/right_arrow3.png" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';

export default {
    name: 'recent',
    data: function()
    {
        return {
            categoryList: null
        }
    },
    mounted: async function()
    {
        const url = `${process.env.API_DB_ROOT}/diabetes/item/organization/categories/5`;
        const response = await axios.get(url);
        this.categoryList = response.data.data;

    },
    methods: {
        searchCategory: function(keyword, type, category)
        {
            this.$emit('searchCategory', keyword, type, category)
        },
        tabChange: function()
        {
            this.$emit('tabChange', 0)
        },
        categoryToString: function(category)
        {
            if(category === 9)
            {
                return '카테고리1'
            }
            else if(category === 10)
            {
                return '카테고리2'
            }          

        }
    }
}
</script>

<style scoped>
    .active-tab-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .inactive-tab-text {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: normal;
    }
    .tabs {
        width: 100%;
        padding: 16px;
        box-sizing: border-box;
        border-bottom: 1px solid #EDEEF0;
    }
    .line {
        background: #1E1E1E;
        width: 100px;
        height: 1.5px;
        margin-left: 116px;
    }
    .category-list {
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        align-items: flex-start;
        box-sizing: border-box;
        padding: 33px 16px 60px 16px;
    }
    .category-title {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 600;
        line-height: 17px; /* 94.444% */
    }
    .category-count-title {
        color: #184FA1;
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 17px;
    }
    .category-element {
        height: 59px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        box-sizing: border-box;
        padding: 0 20px;
        border-radius: 6px;
        background: var(--Gray-20, #F3F5F8);
    }
    .category-element-text {
        color: var(--Gray-100, #1E1E1E);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 17px; /* 94.444% */
    }
    .category-element-count {
        color: var(--Gray-50, #A3AAB6);
        font-family: Pretendard;
        font-size: 18px;
        font-style: normal;
        font-weight: 400;
        line-height: 17px;
    }
    .box {
        width: 100%;
        border-radius: 6px;
        overflow:hidden;
    }
</style>


// WEBPACK FOOTER //
// src/components/molecules/calculator/catheter/Category.vue